import { createContext, type PropsWithChildren, type ReactNode, useContext } from 'react';
import { PLACEHOLDERS } from '../constants/pdf-preview.ts';

interface PlaceholdersContextType {
  activePlaceholders?: PLACEHOLDERS[];
}

interface UsePlaceholdersReturnType {
  showPlaceholder: boolean;
}

const Context = createContext<PlaceholdersContextType | null>(null);

export function usePlaceholders(placeholder: PLACEHOLDERS): UsePlaceholdersReturnType {
  const context = useContext(Context);

  let showPlaceholder = false;

  if (context?.activePlaceholders) {
    showPlaceholder =
      context.activePlaceholders.includes(placeholder) ||
      context.activePlaceholders.includes(PLACEHOLDERS.ALL);
  }

  return { showPlaceholder };
}

export type PlaceholdersContextProps = PlaceholdersContextType;

export function PlaceholdersContext({
  children,
  ...value
}: PropsWithChildren<PlaceholdersContextProps>): ReactNode {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
